import * as client from './client.js';

/**
 * Retrieve a list of fences
 */
export async function getFencesList() {
    return await client.get('/fences');
}

export async function getFence(id) {
    return await client.get(`/fences/${id}`);
}

/**
 * Create a new fence
 */
export async function createFence(fence) {
    return await client.post('/fences', fence);
}

/**
 * Create a new fence
 */
export async function updateFence(id, fence) {
    return await client.post(`/fences/${id}`, fence);
}

/**
 * Delete a new fence
 */
export async function deleteFence(id) {
    return await client.delete(`/fences/${id}`);
}

export async function setOrganizations(id, organizations) {
    return await client.post(`/fences/${id}/organizations`, organizations);
}

export async function setManagers(id, managers) {
    return await client.post(`/fences/${id}/managers`, managers);
}
